import tealium from '../../tealium';
import { registerAnalyticsEventHandler } from '../registry';
import { IDataLayer } from '../../../types';

const defaultData: IDataLayer = {
  signin: {
    event_name: 'signin',
    event_category: 'account',
    event_action: 'login_success',
    event_noninteraction: 'false',
    event_label: null, // source: checkoutSignin/account/inStoreRamp/socialRamp
    account_referrer: null, // provider: email/facebook/line/rakuten/kakao/naver
    account_rememberme: null, // rememberMe: true/false
    account_source: null, // source: checkoutSignin/account/inStoreRamp/socialRamp
  },

  signinFailed: {
    event_name: 'signin_fail',
    event_category: 'account',
    event_action: 'login_fail',
    event_noninteraction: 'false',
    event_label: null, // source: checkoutSignin/account/inStoreRamp/socialRamp
    account_referrer: null, // provider: email/facebook/line/rakuten/kakao/naver
    account_source: null, // source: checkoutSignin/account/inStoreRamp/socialRamp
  },

  // TODO: this hasn't been updated in-line with the rest of the data in this file
  profileUpdate: {
    event_name: 'profile_update',
    event_category: 'account',
    event_action: 'profile update',
    event_value: '0',
    event_noninteraction: 'false',
    event_label: 'standard', // '<type of signin: standard or facebook'>
  },

  registrationFailed: {
    event_name: 'registration_fail',
    event_category: 'account',
    event_action: 'create_fail',
    event_noninteraction: 'false',
    event_label: null, // source: account/checkoutSignin/inStoreRamp/socialRamp
    account_referrer: null, // provider: email/facebook/line/rakuten/kakao/naver
    account_source: null, // source: account/checkoutSignin/inStoreRamp/socialRamp
    account_type: null, // type: partial/complete
  },

  registration: {
    event_name: 'registration',
    event_category: 'account',
    event_action: 'create_success',
    event_noninteraction: 'false',
    event_label: null, // source: account/checkoutSignin/inStoreRamp/socialRamp
    account_referrer: null, // provider: email/facebook/line/rakuten/kakao/naver
    account_source: null, // source: account/checkoutSignin/inStoreRamp/socialRamp
    account_type: null, // type: partial/complete
  },

  signOut: {
    event_name: 'signout',
    event_category: 'account',
    event_action: 'log_out',
    event_label: null,
    account_source: null,
  },

  resetPasswordStart: {
    event_name: 'confirm_email',
    event_category: 'account',
    event_action: 'valid_email_entered',
    event_label: 'valid_email_entered',
  },

  createNewPassword: {
    event_name: 'create_new_password',
    event_category: 'account',
    event_action: 'success',
    event_label: 'create_password_success',
  },

  forgotPassword: {
    event_name: 'forgot_password',
    event_category: 'account',
    event_action: 'click',
    event_label: 'forgot_password',
  },
};

function trackAccount(eventName: string, eventData: IDataLayer = {}) {
  const data = tealium.dataLayer?.data || {};

  eventData.account_referrer = eventData.account_referrer?.toLowerCase() || '';
  eventData.account_source = eventData.account_source?.toLowerCase() || '';
  eventData.event_label = eventData.account_source
    ? eventData.account_source
    : eventData.login_source?.toLowerCase() ||
      eventData?.event_label ||
      defaultData[eventName]?.event_label;
  eventData.ELC_USER_ID = eventData?.USER_ID;
  eventData.location = window.location.origin + window.location.pathname;

  if (data?.page_type === 'checkout') {
    eventData.event_category = 'ecommerce';
  }

  tealium.evtLink({ ...defaultData[eventName], ...eventData });
}

Object.keys(defaultData).forEach((key) => {
  registerAnalyticsEventHandler(key, trackAccount);
});
